angular.module('impactx.autocompletegroup').controller('AutocompleteGroupCtrl', [
    'dataGen',
    'TranslationService',
    AutocompleteGroupController]);

function AutocompleteGroupController(dataGen, TranslationService) {
    var self = this;

    self.searchText = '';
    self.entries = [];
    self.trns = {
        required: TranslationService.get("required"),
        noSelectedItemMessage: TranslationService.get("noSelectedItemMessage"),
        noEntriesFound: TranslationService.get("noEntriesFound")
    };

    self.getItemText = function (entry) {
        if (entry && entry.value) {
            return entry.value;
        }
        else {
            self.searchText = "";
            return undefined;
        }
    };

    self.getEntries = function () {
        var dataObject = {
            searchText: self.searchText,
            hiddenId: self.hiddenId ? self.hiddenId : undefined
        };
        return dataGen.getData({}, dataObject, self.entryPoint, null, true).then(function (data) {
            if (!data.data) {
                return [];
            }
            return impactX.isDefined(data, 'data.entries');
        });
    };
}